import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=007a5b80&scoped=true"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=007a5b80&prod&lang=scss&scoped=true"
import style1 from "./UserManage.vue?vue&type=style&index=1&id=007a5b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a5b80",
  null
  
)

export default component.exports